import React, { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./Chat_Bot.css";
import { SendWhatApp, SendWhatAppContact } from "../../../features/products/productsSlice";
import Success_Modal from "../../common-components/common-modals/success_modal/Success_Modal";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Chat_Bot_Contact = ({ product }) => {
  // ✅ correct props destructuring
  const [successmodal, setSuccessmodal] = useState(false);
  const is_signin = useSelector((state) => state.auth.is_signin);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handelsubmit = async () => {
    if (!is_signin) {
      await navigate("/login");
    } else {
      const res = await dispatch(SendWhatAppContact({ product_id: product?.id }));

      if (res.meta?.requestStatus === "fulfilled") {
        setSuccessmodal(true);
        setTimeout(() => {
          setSuccessmodal(false);
        }, 2000);
      }
    }
  };

  return (
    <>
      <div className="whatsapp_float" onClick={handelsubmit}>
        <FaWhatsapp size={30} />
      </div>

      <Success_Modal
        show={successmodal}
        onHide={() => setSuccessmodal(false)}
        successText={"Sent Inquiry Successfully !"}
      />
    </>
  );
};

export default Chat_Bot_Contact;
